const SvgStorage2 = (props) => (
  <>
    <path fill={props.p20} d="M0 191.01 191.01 0H0v191.01z" />
    <circle cx={15.92} cy={191.01} r={0.99} fill="#001d6c" />
    <circle cx={31.83} cy={191.01} r={0.99} fill="#001d6c" />
    <circle cx={47.75} cy={191.01} r={0.99} fill="#001d6c" />
    <circle cx={63.67} cy={191.01} r={0.99} fill="#001d6c" />
    <circle cx={79.59} cy={191.01} r={0.99} fill="#001d6c" />
    <circle cx={95.5} cy={191.01} r={0.99} fill="#001d6c" />
    <circle cx={111.42} cy={191.01} r={0.99} fill="#001d6c" />
    <circle cx={127.34} cy={191.01} r={0.99} fill="#001d6c" />
    <circle cx={143.25} cy={191.01} r={0.99} fill="#001d6c" />
    <circle cx={159.17} cy={191.01} r={0.99} fill="#001d6c" />
    <circle cx={175.09} cy={191.01} r={0.99} fill="#001d6c" />
    <circle cx={191.01} cy={191.01} r={0.99} fill="#001d6c" />
    <circle cx={31.83} cy={175.09} r={0.99} fill="#001d6c" />
    <circle cx={47.75} cy={175.09} r={0.99} fill="#001d6c" />
    <circle cx={63.67} cy={175.09} r={0.99} fill="#001d6c" />
    <circle cx={79.59} cy={175.09} r={0.99} fill="#001d6c" />
    <circle cx={95.5} cy={175.09} r={0.99} fill="#001d6c" />
    <circle cx={111.42} cy={175.09} r={0.99} fill="#001d6c" />
    <circle cx={127.34} cy={175.09} r={0.99} fill="#001d6c" />
    <circle cx={143.25} cy={175.09} r={0.99} fill="#001d6c" />
    <circle cx={159.17} cy={175.09} r={0.99} fill="#001d6c" />
    <circle cx={175.09} cy={175.09} r={0.99} fill="#001d6c" />
    <circle cx={191.01} cy={175.09} r={0.99} fill="#001d6c" />
    <circle cx={47.75} cy={159.17} r={0.99} fill="#001d6c" />
    <circle cx={63.67} cy={159.17} r={0.99} fill="#001d6c" />
    <circle cx={79.59} cy={159.17} r={0.99} fill="#001d6c" />
    <circle cx={95.5} cy={159.17} r={0.99} fill="#001d6c" />
    <circle cx={111.42} cy={159.17} r={0.99} fill="#001d6c" />
    <circle cx={127.34} cy={159.17} r={0.99} fill="#001d6c" />
    <circle cx={143.25} cy={159.17} r={0.99} fill="#001d6c" />
    <circle cx={159.17} cy={159.17} r={0.99} fill="#001d6c" />
    <circle cx={175.09} cy={159.17} r={0.99} fill="#001d6c" />
    <circle cx={191.01} cy={159.17} r={0.99} fill="#001d6c" />
    <circle cx={63.67} cy={143.25} r={0.99} fill="#001d6c" />
    <circle cx={79.59} cy={143.25} r={0.99} fill="#001d6c" />
    <circle cx={95.5} cy={143.25} r={0.99} fill="#001d6c" />
    <circle cx={111.42} cy={143.25} r={0.99} fill="#001d6c" />
    <circle cx={127.34} cy={143.25} r={0.99} fill="#001d6c" />
    <circle cx={143.25} cy={143.25} r={0.99} fill="#001d6c" />
    <circle cx={159.17} cy={143.25} r={0.99} fill="#001d6c" />
    <circle cx={175.09} cy={143.25} r={0.99} fill="#001d6c" />
    <circle cx={191.01} cy={143.25} r={0.99} fill="#001d6c" />
    <circle cx={79.59} cy={127.34} r={0.99} fill="#001d6c" />
    <circle cx={95.5} cy={127.34} r={0.99} fill="#001d6c" />
    <circle cx={111.42} cy={127.34} r={0.99} fill="#001d6c" />
    <circle cx={127.34} cy={127.34} r={0.99} fill="#001d6c" />
    <circle cx={143.25} cy={127.34} r={0.99} fill="#001d6c" />
    <circle cx={159.17} cy={127.34} r={0.99} fill="#001d6c" />
    <circle cx={175.09} cy={127.34} r={0.99} fill="#001d6c" />
    <circle cx={191.01} cy={127.34} r={0.99} fill="#001d6c" />
    <circle cx={95.5} cy={111.42} r={0.99} fill="#001d6c" />
    <circle cx={111.42} cy={111.42} r={0.99} fill="#001d6c" />
    <circle cx={127.34} cy={111.42} r={0.99} fill="#001d6c" />
    <circle cx={143.25} cy={111.42} r={0.99} fill="#001d6c" />
    <circle cx={159.17} cy={111.42} r={0.99} fill="#001d6c" />
    <circle cx={175.09} cy={111.42} r={0.99} fill="#001d6c" />
    <circle cx={191.01} cy={111.42} r={0.99} fill="#001d6c" />
    <circle cx={111.42} cy={95.5} r={0.99} fill="#001d6c" />
    <circle cx={127.34} cy={95.5} r={0.99} fill="#001d6c" />
    <circle cx={143.25} cy={95.5} r={0.99} fill="#001d6c" />
    <circle cx={159.17} cy={95.5} r={0.99} fill="#001d6c" />
    <circle cx={175.09} cy={95.5} r={0.99} fill="#001d6c" />
    <circle cx={191.01} cy={95.5} r={0.99} fill="#001d6c" />
    <circle cx={127.34} cy={79.59} r={0.99} fill="#001d6c" />
    <circle cx={143.25} cy={79.59} r={0.99} fill="#001d6c" />
    <circle cx={159.17} cy={79.59} r={0.99} fill="#001d6c" />
    <circle cx={175.09} cy={79.59} r={0.99} fill="#001d6c" />
    <circle cx={191.01} cy={79.59} r={0.99} fill="#001d6c" />
    <circle cx={143.25} cy={63.67} r={0.99} fill="#001d6c" />
    <circle cx={159.17} cy={63.67} r={0.99} fill="#001d6c" />
    <circle cx={175.09} cy={63.67} r={0.99} fill="#001d6c" />
    <circle cx={191.01} cy={63.67} r={0.99} fill="#001d6c" />
    <circle cx={159.17} cy={47.75} r={0.99} fill="#001d6c" />
    <circle cx={175.09} cy={47.75} r={0.99} fill="#001d6c" />
    <circle cx={191.01} cy={47.75} r={0.99} fill="#001d6c" />
    <circle cx={175.09} cy={31.83} r={0.99} fill="#001d6c" />
    <circle cx={191.01} cy={31.83} r={0.99} fill="#001d6c" />
    <circle cx={191.01} cy={15.92} r={0.99} fill="#001d6c" />
  </>
);

export default SvgStorage2;
